import * as React from 'react';
import {Link} from 'react-router-dom';

import type {UserPermissions} from 'nutshell-core/users/users-types';

import {AdminLockIcon, CreditCardIcon} from 'shells/icon';

import styles from './sidebar-user.module.css';

type Props = {
    closeSidebar: () => void;
    userPermissions: UserPermissions;
};

export class SidebarUserCompanySection extends React.PureComponent<Props> {
    render() {
        const isTrial = NutClientConfig.isTrial;
        // Pro trial means that a current paying Starter customer
        // is trialing a Pro plan.
        const isProTrial = NutClientConfig.isProTrial;
        const daysLeftInTrial = NutClientConfig.daysLeftInTrial;

        // This will always exist, but we only show it when in a Pro Trial
        const daysLeftInProTrial = NutClientConfig.daysLeftInProPlanTrial;

        if (
            !this.props.userPermissions.canAccessSetup &&
            !this.props.userPermissions.canAccessBilling
        ) {
            return null;
        }

        const setupLinks = [];
        if (this.props.userPermissions.canAccessSetup) {
            setupLinks.push(
                // @ts-expect-error
                <Link
                    key='setup'
                    to='/setup/index'
                    onClick={this.props.closeSidebar}
                    className={styles['link-container']}
                >
                    <AdminLockIcon className={styles['link-icon-settings']} size={32} />
                    <div className={styles['link-text']}>Company settings</div>
                </Link>
            );
        }
        if (
            this.props.userPermissions.canAccessSetup ||
            this.props.userPermissions.canAccessBilling
        ) {
            setupLinks.push(
                // @ts-expect-error
                <Link
                    key='billing'
                    to='/setup/billing/sales'
                    onClick={this.props.closeSidebar}
                    className={styles['link-container']}
                >
                    <CreditCardIcon className={styles['link-icon-settings']} size={32} />
                    <div>
                        <div className={styles['link-text']}>
                            {isTrial ? 'Purchase' : 'Nutshell billing'}
                        </div>
                        {isTrial ? (
                            <div
                                className={
                                    daysLeftInTrial <= 2
                                        ? styles['trial-days-warning']
                                        : styles['trial-days']
                                }
                            >
                                {`${daysLeftInTrial} ${
                                    daysLeftInTrial === 1 ? 'day' : 'days'
                                } remaining in trial`}
                            </div>
                        ) : undefined}
                        {isProTrial ? (
                            <div className={styles['trial-days-pro']}>
                                {`${daysLeftInProTrial} ${
                                    daysLeftInProTrial === 1 ? 'day' : 'days'
                                } remaining in your Pro trial`}
                            </div>
                        ) : undefined}
                    </div>
                </Link>
            );
        }

        return setupLinks.length ? <div className={styles.menu}>{setupLinks}</div> : null;
    }
}
